import { createIdStatusHelpers } from "~/utils/statusLookup";
const helpers = createIdStatusHelpers({
    classPrefix: "entity-status",
    byId: {
        "0": { label: "Inactive", slug: "inactive" },
        "1": { label: "Active", slug: "active" },
        "2": { label: "Archived", slug: "archived" },
    },
});
export function getEntityActiveStatusMeta(value) {
    return helpers.getMeta(value);
}
export function getEntityActiveStatusOption(flag) {
    return helpers.getOption(flag);
}
